import React from "react";
import NewNavbar from "./newNavbar";
import Footer from "./Footer";
import "../styles/global.css";

// Website brand colors
const brandBg = "#f5f6fa"; // Light background
const brandAccent = "#fc46aa"; // Pink accent (matches nav hover and highlights)
const brandText = "#222";

export default function NotFoundPage() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: brandBg }}>
      <NewNavbar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", textAlign: "center", padding: 32 }}>
        <h1 style={{ fontSize: 72, color: brandAccent, marginBottom: 0, fontWeight: 800, letterSpacing: 2 }}>404</h1>
        <h2 style={{ color: brandText, marginTop: 0, marginBottom: 16, fontWeight: 700 }}>Page Not Found</h2>
        <p style={{ color: "#666", maxWidth: 400, marginBottom: 32, fontSize: 18 }}>
          Oops! The page you are looking for does not exist or has been moved.<br />
          Please check the URL or return to the homepage.
        </p>
        <a href="/" style={{
          background: brandAccent,
          color: "#fff",
          padding: "12px 32px",
          borderRadius: 8,
          textDecoration: "none",
          fontWeight: 700,
          fontSize: 20,
          boxShadow: "0 2px 8px rgba(252,70,170,0.10)",
          transition: "background 0.2s, box-shadow 0.2s",
          letterSpacing: 0.5,
          marginTop: 8,
          display: "inline-block"
        }}>Go to Homepage</a>
      </div>
      <Footer />
    </div>
  );
}
